export enum MawChromeLauncherViewMode {
  One_Monitor__0 = "1",
  Two_Monitors_Row__1 = "2",
  Two_Monitors_Row_Unequal__10 = "2",
  Two_Monitors_Row_Unequal_Reversed__9 = "2",
  Tree_Monitors_1_Row_2_3_Column__11 = "3",
  Tree_Monitors_1_2_Column_3_Row__12 = "3",
  Three_Monitors_Row__2 = "3",
  Four_Monitors__3 = "4",
  Five_Monitors_1_Row_Rest_Column__4 = "5",
  Five_Monitors_5_Column__5 = '5',
  Five_Monitors_1_2_Column_3_Row_4_5_Column_Centered__14 = "5",
  Six_Monitors__6 = "6",
  Nine_Monitors__13 = "9",
  Two_Monitors_Portrait__7 = "2",
  Three_Monitors_Portrait__8 = "3"
}
